import axios from "axios";
import store from "../store";

export const interceptorsSetup = () => {
  axios.interceptors.request.use(
    config => {
      let userData = JSON.parse(localStorage.getItem("userData"));
      if (!config.url.includes("/login/access-token")) {
        config.headers["Accept"] = "application/json";
        if (userData && userData["access_token"] && !config.url.includes("/file")) {
          config.headers["Authorization"] = `Bearer ${userData["access_token"]}`;
        }
        if (config.url.includes("/login/refresh-token")) {
          delete config.headers["Authorization"];
        }
      } else {
        config.headers["Content-Type"] = "multipart/form-data";
      }
      return Promise.resolve(config);
    },
    error => Promise.reject(error)
  );
};

let isRefreshing = false;
let subscribers = [];

function subscribeTokenRefresh(cb) {
  subscribers.push(cb);
}

function onRefreshSuccess() {
  subscribers.forEach(cb => cb(/* success */));
  subscribers = []; // ✅ Clear after firing
}

function onRefreshFailure() {
  subscribers.forEach(cb => cb(new Error("Refresh failed"), null));
  subscribers = []; // ✅ Clear on failure too
}

export function interceptorsResponse() {
  axios.interceptors.response.use(
    response => Promise.resolve(response),
    function (error) {
      const { status, data: { detail: { token } = {} } = {} } = error.response || {};
      const originalRequest = error.config;

      // ✅ Bail out immediately for refresh-token endpoint to avoid loop
      if (originalRequest.url.includes("/login/refresh-token")) {
        return Promise.reject(error);
      }

      if (status === 403) {
        if (!isRefreshing) {
          isRefreshing = true;

          store
            .dispatch("refreshToken")
            .then(({ status }) => {
              if (status === 200 || status === 204) {
                onRefreshSuccess(); // ✅ Notify + clear subscribers
              }
            })
            .catch(refreshErr => {
              const { response: { status: refreshStatus } = {} } = refreshErr || {};
              if (refreshStatus === 403) {
                store.dispatch("logout");
              }
              onRefreshFailure(); // ✅ Reject + clear subscribers on any failure
            })
            .finally(() => {
              isRefreshing = false; // ✅ Always reset flag
            });
        }

        // ✅ Queue the failed request and retry after refresh
        return new Promise((resolve, reject) => {
          subscribeTokenRefresh(err => {
            if (err) return reject(err); // ✅ Properly reject queued requests on failure
            resolve(axios(originalRequest));
          });
        });
      }

      if (status === 401 && token) {
        store.dispatch("redirectToReset", token);
        return;
      }

      if (status === 419) {
        store.dispatch("forceLogout");
        store.dispatch("clearAllToast");
        store.dispatch("showToast", {
          class: "bg-danger text-white",
          message: "You have been logged out, as a new login session for the same credentials has been detected!",
          autohide: 7000
        });
        return;
      }

      return Promise.reject(error);
    }
  );
}